import React from 'react'
import PropTypes from 'prop-types'
import { TextField, Button } from '@material-ui/core'
import { Field } from 'react-formality'
import classNames from 'classnames'
import Form from './components/Form'
import connectPropTypes from './utilities/connectPropTypes'
import getShortName from './utilities/Data/User/getShortName'
import getField from './utilities/Data/getField'
import validateUserProfileUserNameAvailable from './dataservices/validateUserProfileUserNameAvailable'
import userNameRules from './utilities/Data/User/userNameRules'
import styles from './Onboard.icss'
import User from './utilities/Data/User'
import getStartLocationForUser from './utilities/getStartLocationForUser'

class Onboard extends React.Component {
	constructor(props) {
		super(props)

		this.state = { userNameChanged: false, userNameAvailable: true }
		this.form = React.createRef()
		this.validate = this.validate.bind(this)
		this.submitHandler = this.submitHandler.bind(this)
	}

	componentDidMount() {
		if (User.isOnboardingComplete(this.props.user)) {
			// when onboarding complete, redirect to the correct path
			this.props.appRedirect(getStartLocationForUser(this.props.user))
		} else {
			this.props.appNextButtonIsLoading(false)
			this.mounted = true
			this.props.appHeading({ text: this.context.translate('Your details') })

			this.props.appShowBottomBar(false)
			this.props.appShowBottomNavBar(true)
			this.props.appBottomNavBarHandleClick(() => {
				this.props.appNextButtonIsLoading(true)
				this.form.current.submit()
			})
			this.props.appBottomNavBarLabelNext(this.context.translate('Next'))
		}
	}

	componentDidUpdate() {
		if (User.isOnboardingComplete(this.props.user)) {
			this.props.appRedirect(getStartLocationForUser(this.props.user))
		}
	}

	componentWillUnmount() {
		this.props.appNextButtonIsLoading(false)
		this.mounted = false
	}

	submitHandler({ values, isValid }) {
		if (isValid) {
			this.props.userProfileOnboardSubmit({ values }, {
				reserveUserName: this.state.userNameChanged
			})
		} else {
			this.props.appNextButtonIsLoading(false)
		}
	}

	async validate(value) {
		if (!value) {
			return undefined
		}
		const userNameAvailable = await validateUserProfileUserNameAvailable(value)
		this.setState(() => ({ userNameAvailable }))
		return userNameAvailable ? undefined : this.context.translate('is already in use')
	}

	render() {
		const userProfile = getField(this.props.user, 'userProfile')
		const shortName = getShortName(this.props.user)
		const headingText = shortName ? this.context.translate('Welcome {shortName}', { shortName }) : this.context.translate('Welcome')
		const isCanonicalEmail = getField(userProfile, 'isCanonicalEmail')

		return (!userProfile ? null : (
			<section>
				<Form
					onSubmit={this.submitHandler}
					className={classNames(styles.oneColumn, styles.pagePadding)}
					initialValues={{
						fullName: getField(userProfile, 'fullName') || '',
						userName: getField(userProfile, 'userName') || '',
						email: getField(userProfile, 'email') || ''
					}}
					ref={this.form}
				>
					{props => (
						<React.Fragment>
							<h2>{headingText}</h2>
							{this.props.verifiedUserObject && this.props.verifiedUserObject.realName &&
								<p>{this.context.translate('You and {verifiedUser} are now verified!', { verifiedUser: this.props.verifiedUserObject.realName })}</p>
							}
							<p>
								{this.context.translate('Enter your full name as you would like it to appear on your Kitfit profile')}
							</p>
							<Field
								component={TextField}
								name="fullName"
								className={styles.nameText}
								placeholder={this.context.translate('What is your full name?')}
								label={this.context.translate('Full Name')}
								value={props.values.fullName}
								validate={{
									presence: true
								}}
							/>
							{!isCanonicalEmail && (
								<Field
									component={TextField}
									name="email"
									placeholder={this.context.translate('What is your email address?')}
									label={this.context.translate('Email')}
									value={props.values.email}
									type="email"
									disabled={isCanonicalEmail}
									validate={{
										presence: true,
										email: true
									}}
								/>
							)}

							<h3>{this.context.translate('Your Kitfit username')}</h3>
							<Field
								component={TextField}
								name="userName"
								placeholder={this.context.translate('Choose a username')}
								label={this.context.translate('Username')}
								value={props.values.userName}
								onChange={() => this.setState({ userNameChanged: true })}
								inputProps={{
									maxLength: 30
								}}
								validate={{
									presence: true,
									asyncValidator: {
										validate: this.state.userNameChanged ? this.validate : undefined,
										debounce: {
											duration: 300
										},
										cache: {
											duration: 10000
										}
									},
									formats: {
										rules: userNameRules
									},
									length: {
										maximum: 30,
										tooLong: this.context.translate('can be up to 30 characters')
									}
								}}
							/>
							{this.state.userNameAvailable &&
								<p>{this.context.translate('is available! Click next to continue.')}</p>
							}
							{!!getField(userProfile, 'onboardingSuggestedUserNames.length') && !this.state.userNameAvailable && (
								<p>
									{this.context.translate('You can enter an alternaive username above or choose from the available options:')}<br />
									{getField(userProfile, 'onboardingSuggestedUserNames').map(suggestion => (
										<Button
											key={suggestion}
											color="primary"
											className={styles.userNameSuggestion}
											onClick={() => props.store.set('userName', suggestion)}
										>
											{suggestion}
										</Button>
									))}
								</p>
							)}
						</React.Fragment>
					)}
				</Form>
			</section>
		))
	}
}

Onboard.contextTypes = {
	translate: PropTypes.func
}

Onboard.propTypes = {
	appHeading: PropTypes.func.isRequired,
	appNextButtonIsLoading: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	appRedirect: PropTypes.func.isRequired,
	userProfileOnboardSubmit: PropTypes.func.isRequired,
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	verifiedUserObject: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

Onboard.defaultProps = {
	verifiedUserObject: undefined
}

export default connectPropTypes(Onboard)



// WEBPACK FOOTER //
// ./src/Onboard.jsx